import React from "react";
import NoDataFound from "./NoDataFound";
import MavStats from "../../Assets/images/mav-stats.svg";
import ApiFailedError from "./ApiFailedError";
function MavSummary({ childSummary, summaryLoading, isError }: any) {
    const isNoData = !summaryLoading && (childSummary === null || (childSummary && childSummary.scans.value === 0));
    return (
        <div className="row">
            <div className="col-xs">
                <div className={summaryLoading ? "box offset-padding loading" : isNoData ? "box" : "box offset-padding"}>
                    {isNoData ? (
                        isError ? (
                            <ApiFailedError fromApiError />
                        ) : (
                            <NoDataFound />
                        )
                    ) : (
                        <div className="box-header">
                            <div className="box-title-container">
                                    <div role="option" className="box-title-icon">
                                        <img src={MavStats} style={{ height: "32px" }} alt="icon" />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">Mobile Attack View Summary</h2>
                                </div>
                            </div>

                            {childSummary && (
                                <div className="box-description">
                                    <div className="row ml-1">
                                        <div className="col-xs-6 col-md-3 col-gutter-vertical flex-center">
                                            <div className="service-container">
                                                <div className="service-title">
                                                    <h3>Employees</h3>
                                                </div>
                                                <div className="service-content">
                                                    <h2>{childSummary.users.value}</h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 col-md-3 col-gutter-vertical flex-center">
                                            <div className="service-container">
                                                <div className="service-title">
                                                    <h3>Devices</h3>
                                                </div>
                                                <div className="service-content">
                                                    <h2>{childSummary.devices.value}</h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 col-md-3 col-gutter-vertical flex-center">
                                            <div className="service-container">
                                                <div className="service-title">
                                                    <h3>Scans</h3>
                                                </div>
                                                <div className="service-content">
                                                    <h2>{childSummary.scans.value}</h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 col-md-3 col-gutter-vertical flex-center">
                                            <div className="service-container">
                                                <div className="service-title">
                                                    <h3>Risks</h3>
                                                </div>
                                                <div className="service-content">
                                                    <h2>{childSummary.risks.value}</h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default MavSummary;
